import { useTrans } from "core/index.js";

export default function ApartmentCard({ title, image, desc, price, currency, rating = 0, onClick, status }) {
	// Chip color based on status
	const statusStyles = {
		published: "bg-green-600 text-white",
		pending: "bg-yellow-500 text-black",
		unacceptable: "bg-red-600 text-white",
	};
	const { t } = useTrans();
	return (
		<div
			onClick={onClick}
			className="bg-white rounded-xl shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition relative"
		>
			{status && (
				<div className={`absolute top-2 right-2 px-3 py-1 text-sm rounded-lg shadow ${statusStyles[status]}`}>
					{t(`customApartment.${status}`)}
				</div>
			)}

			<img src={image} alt={title} className="w-full h-48 object-cover" />

			<div className="p-4">
				<h3 className="text-lg font-semibold">{title}</h3>
				<h2 className="text-md text-gray-700">{desc}</h2>
				<p className="text-gray-600 mt-1">
					{price} {currency ? currency : "ليرة سورية"}
				</p>

				<div className="flex items-center mt-3">
					{Array.from({ length: 5 }).map((_, i) => (
						<svg
							key={i}
							className={`w-5 h-5 ${i < rating ? "text-yellow-400" : "text-gray-300"}`}
							fill="currentColor"
							viewBox="0 0 20 20"
						>
							<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.95-.69l1.07-3.292z" />
						</svg>
					))}
				</div>
			</div>
		</div>
	);
}
